//Amalgate all subsection adapters

import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import { AdapterOptions, FlatAnswerMutation } from 'components/Assessments/adapters/types'
import { OverviewAdapter } from './subsections/overview/adapter'
import { BaseSubsectionAdapter } from '../../../adapters/BaseSubsectionAdapter'
import { RocFormData } from '../../types/RocFormData'

const RESUMPTION_OVERVIEW_SECTION_ADAPTERS: BaseSubsectionAdapter<RocFormData>[] = [
  new OverviewAdapter()
]

export class ResumptionOverviewAdapter extends BaseSubsectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    options?: AdapterOptions
  ): Partial<RocFormData> {
    const formData: Partial<RocFormData> = {}
    for (const adapter of RESUMPTION_OVERVIEW_SECTION_ADAPTERS) {
      const sectionData = adapter.extractFormData(flatAnswers, options)
      Object.assign(formData, sectionData)
    }
    return formData
  }

  buildFlatAnswers(): FlatAnswerMutation[] {
    const mutations: FlatAnswerMutation[] = []

    for (const adapter of RESUMPTION_OVERVIEW_SECTION_ADAPTERS) {
      adapter.setFormData(this.formData)
      const sectionMutations = adapter.buildFlatAnswers()
      mutations.push(...sectionMutations)
    }

    return mutations
  }
}
